// extracted by mini-css-extract-plugin
export default {"checkbox":"src-components-Antd-Checkbox-css-module__checkbox--icCfZ"};